import getActionsByDocument from '../../../../../../components/logs/actions';

const DOCUMENT = 'DISTRICT_LOGS_';

export default getActionsByDocument(DOCUMENT);
